// Module
var code = "<svg height=\"30\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"5.5\" cy=\"14.5\" r=\"2.5\"/><circle cx=\"23.5\" cy=\"14.5\" r=\"2.5\"/><circle cx=\"14.5\" cy=\"14.5\" r=\"2.5\"/></svg>";
// Exports
module.exports = code;